import ErrorMessages from '../../../../constants/error-messages';
import { SCORE_VALUE } from '../../../../constants/sentimentScore.constant';
import { SentimentType } from '../../../../types/Sentiment.type';

export const getScoreLabel = (score: number) => {
  if (score >= SCORE_VALUE.EXCELLENT) return SentimentType.EXCELLENT;
  if (score >= SCORE_VALUE.GOOD) return SentimentType.GOOD;
  if (score >= SCORE_VALUE.NEEDS_IMPROVEMENT)
    return SentimentType.NEEDS_IMPROVEMENT;
  return ErrorMessages.STORY_ANALYTICS.REQUIRES_REVISION;
};
